// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4616":"css/admin-app.6903","8629":"css/app.6903"}[chunkId] + ".css";
};